import axios from 'axios';

const state = {
    uploading: false,
    uploadProgress: null
};

const getters = {
    uploading: state => {
        return state.uploading;
    },
	uploadProgress: state => {
		return state.uploadProgress;
	}
};

const mutations = {
	setUploading(state, payload) {
        state.uploading = payload;
    },
	setProgress(state, payload) {
		state.uploadProgress = payload;
	}
}

const actions = {
	async upload({commit}, payload) {
		commit('setUploading', true);
		let res = null;

		let formData = new FormData();
		Object.keys(payload).forEach(key => {
			formData.append(key, payload[key]);
		});

		/*
			const headers = {
				'Content-Type': 'multipart/form-data'
			}
		*/

		const config = {
			onUploadProgress: function(progressEvent) {
				let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
				commit('setProgress', percentCompleted)
			}
		}

		await axios.post('files', formData,
			config)
			.then(response => {
			res = {
				success: true,
				error: null,
				data: response.data.data,
				token: response.data.data.token
			}
		})
		.catch(error => {
			res = {
				success: false,
				error: error,
				data: null,
				token: null
			}
		})
		commit('setUploading', false)
		return res;
	},
	async uploadPhoto({dispatch}, payload) {
		let data = Object.assign({}, payload);
		data.type = 'image'
		return dispatch('upload', data);
	},
	async uploadVideo({dispatch}, payload) {
		let data = Object.assign({}, payload);
		data.type = 'video'
		const response = dispatch('upload', data);
		return response;
	},
	async uploadAttachment({dispatch}, payload) {
		let data = Object.assign({}, payload);
		data.type = 'attachment'
		return dispatch('upload', data);
	},
	/* eslint-disable */
	async deleteFile({commit}, payload) {
		let res = {};
		await axios.delete('files/' + payload.id)
			.then(response => {
				res = {
					success: true,
					data: response.data.data,
					error: false
				}
			})
			.catch(error => {
				res = {
					success: false,
					data: null,
					error: error
				}
			});

			return res;
	}

	/* eslint-enable */
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
    actions,
};
